import React, { useState } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  Menu,
  Grid,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Logo from "../Images/R1.png";
import CtBtn from "./CustomTool/CtBtn";
import {
  Calculate,
  Description,
  Inventory,
  LocalShipping,
  Receipt,
  Store,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";

const LINKS = [
  { label: "Home", key: "/" },
  { label: "Solution" },
  { label: "Price", key: "/PricingPlans" },
  { label: "About", key: "/about" },
  { label: "Partner with US", key: "/partner" },
  //  { label: "Contact", key: "/contact" },
  { label: "Login", key: "/login" },
];

export default function ResponsiveNavbar() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  // Mobile Solution toggle
  const [mobileSolutionOpen, setMobileSolutionOpen] = useState(false);

  // Desktop Solution menu
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpenSolution = (event) => setAnchorEl(event.currentTarget);
  const handleCloseSolution = () => setAnchorEl(null);
  const solutionOpen = Boolean(anchorEl);
  const toggleDrawer = (value) => () => setOpen(value);

  const drawerList = (
    <Box sx={{ height: "100%", bgcolor: "white" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          justifyContent: "space-between",
        }}
      >
        <img src={Logo} alt="Rite Logo" style={{ width: "60px" }} />
        <IconButton onClick={toggleDrawer(false)} aria-label="close menu">
          <CloseIcon />
        </IconButton>
      </Box>

      <List sx={{ px: 2 }}>
        {LINKS.map((link) =>
          link.label === "Solution" ? (
            <React.Fragment key="solution">
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => setMobileSolutionOpen(!mobileSolutionOpen)}
                >
                  <ListItemText primary="Solution" />
                  {mobileSolutionOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
              <Collapse in={mobileSolutionOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{ pl: 4 }}>
                  {[
                    "Accounting",
                    "Inventory",
                    "Invoicing",
                    "E-Invoice",
                    "POS",
                    "OCR",
                  ].map((item) => (
                    <ListItemButton
                      key={item}
                      sx={{ py: 0.5 }}
                      onClick={() => {
                        navigate(`/${item}`);
                        setMobileSolutionOpen(false);
                        toggleDrawer(false);
                      }}
                    >
                      <ListItemText primary={item} />
                    </ListItemButton>
                  ))}
                  <Typography sx={{ mt: 1, ml: 2, fontWeight: 600 }}>
                    Industry Solution
                  </Typography>
                  {[
                    "Retail",
                    "Pharmacy",
                    "Grocery",
                    "Restaurant",
                    "Jewellery",
                    "Clothing/Apparel",
                  ].map((item) => (
                    <ListItemButton key={item} sx={{ py: 0.5 }}>
                      <ListItemText primary={item} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          ) : (
            <ListItem key={link.label} disablePadding>
              <ListItemButton>
                <ListItemText
                  primary={link.label}
                  onClick={() => {
                    navigate(link.key);
                  }}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: theme.palette.primary.main,
                      color: "white",
                      "&:hover": {
                        backgroundColor: theme.palette.primary.dark,
                      },
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          )
        )}
      </List>
    </Box>
  );

  return (
    <AppBar
      position="sticky"
      elevation={1}
      sx={{ bgcolor: "white", color: "black" }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <img src={Logo} alt="Rite Logo" style={{ width: "60px" }} />
        </Box>

        {/* Desktop links */}
        {!isMobile && (
          <Box sx={{ display: "flex", gap: 1 }}>
            {LINKS.map((link) =>
              link.label === "Solution" ? (
                <CtBtn
                  key={link.label}
                  onClick={handleOpenSolution}
                  variant="text"
                  label={link.label}
                  sx={{
                    textTransform: "none",
                    fontWeight: location.pathname === link.key ? "700" : "400",
                    color:
                      location.pathname === link.key
                        ? theme.palette.primary.main
                        : "inherit",
                    borderBottom:
                      location.pathname === link.key
                        ? `2px solid ${theme.palette.primary.main}`
                        : "none",
                  }}
                />
              ) : (
                <CtBtn
                  key={link.label}
                  onClick={() => navigate(link.key)}
                  variant="text"
                  label={link.label}
                  sx={{
                    textTransform: "none",
                    fontWeight: location.pathname === link.key ? "700" : "400",
                    color:
                      location.pathname === link.key
                        ? theme.palette.primary.main
                        : "inherit",
                    borderBottom:
                      location.pathname === link.key
                        ? `2px solid ${theme.palette.primary.main}`
                        : "none",
                  }}
                />
              )
            )}
          </Box>
        )}

        {/* Mobile hamburger */}
        {isMobile && (
          <IconButton edge="end" aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="top"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{ sx: { height: "100vh", bgcolor: "white" } }}
      >
        {drawerList}
      </Drawer>

      {/* Desktop Solution dropdown */}
      <Menu
        anchorEl={anchorEl}
        open={solutionOpen}
        onClose={handleCloseSolution}
        PaperProps={{
          sx: { mt: 1, p: 2, borderRadius: 2, minWidth: 100, width: 300 },
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          Business Management Solutions
        </Typography>

        <Grid container spacing={2} justifyContent={"flex-start"}>
          {[
            {
              label: "Accounting",
              icon: <Calculate fontSize="5px" />,
              color: "#ffdcd8",
              onClick: () => navigate("/Accounting"),
            },
            {
              label: "Inventory",
              icon: <Inventory fontSize="5px" />,
              color: "#d7f9b4",
              onClick: () => navigate("/Inventory"),
            },
            {
              label: "Invoicing",
              icon: <Receipt fontSize="5px" />,
              color: "#eed3f9",
              onClick: () => navigate("/Invoicing"),
            },
            {
              label: "E-Invoice",
              icon: <Description fontSize="5px" />,
              color: "#d8fbff",
              onClick: () => navigate("/E-Invoice"),
            },
            {
              label: "E-Way Bill",
              icon: <LocalShipping fontSize="5px" />,
              color: "#cfdbf5",
              onClick: () => navigate("/E-WayBill"),
            },
            {
              label: "Transport",
              icon: <LocalShipping fontSize="5px" />,
              color: "#ffebcc",
              onClick: () => navigate("/Transport"),
            },
            {
              label: "APMC Commission Agents",
              icon: <Store fontSize="5px" />,
              color: "#ccffd3ff",
              onClick: () => navigate("/APMCCommissionAgent"),
            },
          ].map((item) => (
            <Grid key={item.label} item xs={6}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                  padding: "2px",
                  "&:hover": {
                    backgroundColor: item.color,
                    borderRadius: "5px",
                  },
                }}
                onClick={item.onClick}
              >
                <Box
                  sx={{
                    backgroundColor: item.color, // yahaan apna color set karo
                    p: 0.2, // padding
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </Box>
                <Typography fontSize={"13px"}>{item.label}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Menu>
    </AppBar>
  );
}
